module.exports = __webpack_public_path__ + "img/22m.e25a710b.png";